import { NavLink, Outlet, useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/lib/auth";
import { LayoutDashboard, MapPin, FileText, Calendar, Receipt, FileSignature, LogOut, Home } from "lucide-react";

const ITEMS = [
  { to: "/portal", icon: LayoutDashboard, label: "Overview", end: true },
  { to: "/portal/tracking", icon: MapPin, label: "Live tracking" },
  { to: "/portal/reports", icon: FileText, label: "Reports" },
  { to: "/portal/schedule", icon: Calendar, label: "Schedule" },
  { to: "/portal/contracts", icon: FileSignature, label: "Contracts" },
  { to: "/portal/invoices", icon: Receipt, label: "Invoices" },
];

export const PortalLayout = () => {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const current = ITEMS.find(i => i.end ? loc.pathname === i.to : loc.pathname.startsWith(i.to)) || ITEMS[0];

  useEffect(() => {
    document.body.classList.add("theme-light");
    document.body.style.background = "#F4F6F9";
    document.body.style.color = "#0D1B2A";
    return () => {
      document.body.classList.remove("theme-light");
      document.body.style.background = "";
      document.body.style.color = "";
    };
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: "#F4F6F9", color: "#0D1B2A" }}>
      <header style={{ background: "#0D1B2A", color: "#fff" }}>
        <div className="max-w-6xl mx-auto px-6 py-5 flex items-center justify-between">
          <Logo size={60} />
          <div className="flex items-center gap-4">
            <Link to="/" className="inline-flex items-center gap-1.5" style={{ color: "#8CA0B8", fontSize: 13 }} data-testid="back-to-site-portal">
              <Home size={14} /> Back to site
            </Link>
            <div className="text-right">
              <div style={{ fontSize: 13 }}>{user?.name}</div>
              <div className="text-muted" style={{ fontSize: 11 }}>Client portal</div>
            </div>
            <button onClick={logout} className="btn-outline flex items-center gap-2" data-testid="portal-logout">
              <LogOut size={14} /> Sign out
            </button>
          </div>
        </div>
        <div className="max-w-6xl mx-auto px-6 flex gap-1">
          {ITEMS.map(i => (
            <NavLink key={i.to} to={i.to} end={i.end}
                     className={({ isActive }) => `px-4 py-3 flex items-center gap-2 ${isActive ? "" : "text-muted"}`}
                     style={({ isActive }) => ({
                       color: isActive ? "#2ECAC8" : "#8CA0B8",
                       borderBottom: isActive ? "2px solid #2ECAC8" : "2px solid transparent",
                       fontSize: 14,
                     })}
                     data-testid={`pnav-${i.label}`}>
              <i.icon size={16} />
              {i.label}
            </NavLink>
          ))}
        </div>
      </header>
      <div className="max-w-6xl mx-auto px-6 py-8">
        <h1 style={{ fontSize: 22, fontWeight: 500, color: "#0D1B2A", marginBottom: 24 }}>{current.label}</h1>
        <Outlet />
      </div>
    </div>
  );
};
